<template>
  <div id="app">
    <demo-mode/>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
const default_layout = "default";
export default {
  name: "app",
  components: {},
  data() {
    return {
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
};
</script>

<style lang="scss">
#app {
}
</style>
